export interface UserPresence {
  id: string;
  name: string;
  color: string;
  taskId: string;
}

const colors = ["bg-red-500", "bg-green-500", "bg-blue-500", "bg-purple-500"];

export function simulatePresence(tasks: string[]): UserPresence[] {
  return Array.from({ length: 3 }).map((_, i) => ({
    id: `user-${i}`,
    name: `U${i + 1}`,
    color: colors[i],
    taskId: tasks[Math.floor(Math.random() * tasks.length)],
  }));
}
